import { visT } from "views/components/visualizations/visualizationTranslation";
import Viewport from "views/logic/aggregationbuilder/visualizations/Viewport";
import WorldMapVisualizationConfig from "views/logic/aggregationbuilder/visualizations/WorldMapVisualizationConfig";
import WorldMapVisualization from "views/components/visualizations/worldmap/WorldMapVisualization";
const DEFAULT_FORM_VALUES = {
  zoom: 1,
  centerX: 0,
  centerY: 0
};
const worldMap = {
  type: WorldMapVisualization.type,
  get displayName() {
    return visT("vis_types.world_map");
  },
  component: WorldMapVisualization,
  config: {
    createConfig: () => DEFAULT_FORM_VALUES,
    fromConfig: (config) => {
      if (!config) {
        return DEFAULT_FORM_VALUES;
      }
      return {
        zoom: config.viewport.zoom,
        centerX: config.viewport.center[0],
        centerY: config.viewport.center[1]
      };
    },
    toConfig: (formValues) => WorldMapVisualizationConfig.create(Viewport.create([formValues.centerX, formValues.centerY], formValues.zoom)),
    fields: [
      {
        name: "zoom",
        get title() {
          return visT("vis_worldmap.zoom");
        },
        type: "numeric",
        required: true
      },
      {
        name: "centerX",
        get title() {
          return visT("vis_worldmap.latitude");
        },
        type: "numeric",
        required: true,
        step: "any"
      },
      {
        name: "centerY",
        get title() {
          return visT("vis_worldmap.longitude");
        },
        type: "numeric",
        required: true,
        step: "any"
      }
    ]
  }
};
export default worldMap;
